/* eslint-disable */
//const domain = 'http://localhost:5102/api/v1/client';
const hostname = window && window.location && window.location.origin;
const basePath = "/firm_api";
const domain = `${hostname}${basePath}/v1/client`

/* eslint-disable end */

export default {
    getAllClients: `${domain}/GetClients`,
    getClientTypesLookUp: `${domain}/GetClientTypeLookUpData`,
    getGenerationTypesLookUp: `${domain}/GetGenerationTypeLookUpData`,
    getLocationLookUp: `${domain}/GetFirmBranchLookUpData`,
    getTaskTypeLookUp: `${domain}/GetTaskTypeLookUpData`,
    getGroupLookUp: `${domain}/GetClientGroupLookUpData`,
    saveAllClients: `${domain}/AddUpdateClients`,
    getClientById: `${domain}/GetClientById`,
    getFirmSettings: `${domain}/GetFirmSettings`,
    unlinkClients: `${domain}/UnLinkClient`,
    getStaffAssignmentLookUp: `${domain}/GetStaffAssignmentDetails`,
    getSearchUserDetails: `${domain}/GetSearchUserDetails`,
    updateStaffDetails: `${domain}/UpdateStaffDetails`,
};
